export default __webpack_public_path__ + "static/media/add-learners.9f201cc8.svg";